import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "backendError" })
export class BackendErrorPipe implements PipeTransform {
  transform(
    response: any,
    type?: "string" | "array",
    EOL = ", ",
  ): string | string[] {
    const errors = [];

    if (response === null || response === undefined) {
      return type === "string" ? "" : errors;
    }

    if (typeof response === "string") {
      return type === "string" ? response : [response];
    }

    const err = response.error || response;

    if (!err && !response.message) {
      return;
    }

    if (err.message) {
      errors.push(err.message);
    }

    if (err.errors && Array.isArray(err.errors.errors)) {
      err.errors.errors.forEach((error) => {
        errors.push(error);
      });
    }

    if (err.errors && err.errors.children) {
      Object.keys(err.errors.children).forEach((key) => {
        const childErrors = err.errors.children[key].errors;
        if (childErrors && Array.isArray(childErrors)) {
          childErrors.forEach((childError) => {
            errors.push(`${key}: ${childError}`);
          });
        }
      });
    }

    if (type === "string") {
      return errors.join(EOL);
    }

    return errors;
  }
}
